import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { TenantService } from '@app/core/tenant/tenant.service';

@Component({
  selector: 'app-sidebar-top',

  imports: [],
  templateUrl: './sidebar-top.component.html',
  styleUrl: './sidebar-top.component.css'
})
export class SidebarTopComponent {
  tenant = inject(TenantService)
  router = inject(Router)


  handleRoute() {
    this.router.navigate([APP_ROUTES.DASHBOARD]).then();
  }
}
